export {
  CASE_STUDY_BEFORE_AFTER,
  CASE_STUDY_CLIENT,
  CASE_STUDY_CLIENT_URL,
  CASE_STUDY_EVIDENCE_CAPTION,
  CASE_STUDY_EVIDENCE_LABEL,
  CASE_STUDY_FOOTNOTE,
  CASE_STUDY_METRICS,
  CASE_STUDY_OUTCOME,
} from "../../roofing/caseStudy/caseStudyContent";

import { LANDING_PATHS } from "@/lib/landingPaths";

export const PARTNER_CASE_STUDY = {
  tag: "LIVE DEPLOYMENT // HOME SERVICES",
  headline: "Real outcomes your agency can sell",
  subline:
    "You deploy vertical-ready Digital Assistants for each client niche. Here is one live home-services deployment and the weekly uplift after go-live.",
  sidebarMeta: "Partner deploy · Real client · Australia",
  leadParts: {
    beforeLink: "A partner white-labeled the Roofing Digital Assistant for ",
    linkText: "Oz Exteriors",
    afterLink:
      ". The client began booking +6 additional qualified appointments per week. Inbound leads were captured in under 9 seconds, including after hours, while the office still relied on a 30–40 minute callback.",
  },
  productLabel: "See the full Roofing Digital Assistant spec",
  productLink: LANDING_PATHS.roofing,
};
